import React from "react";
import { createPortal } from "react-dom";
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineWrongLocation } from "react-icons/md";
import "./LocationNotFoundStyle.css";

const LocationNotFoundPopup = ({
    isOpen,
    closeModal,
    className = "",
    title = "Current location not available",
    message = (
        <>
            We couldn't find your current location in our list yet. Please search for
            the nearest city in the <strong>"City You Live In"</strong> field.
        </>
    ),
}) => {
    if (!isOpen) return null;

    const popupContent = (
        <div
            className={`location_not_found_popup ${className}`}
            role="alertdialog"
            aria-modal="false"
            aria-labelledby="location-not-found-title"
            aria-describedby="location-not-found-message"
        >
            <div className="location_not_found_icon_wrap" aria-hidden="true">
                {/* <MdOutlineWrongLocation className="location_not_found_icon" /> */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.752 11.901c.16-.621.244-1.26.248-1.901a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.292-.077" stroke="#E3E8EF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM21.5 15.5l-5 5M21.5 20.5l-5-5" stroke="#E3E8EF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <div className="location_not_found_content">
                <div
                    className="location_not_found_title"
                    id="location-not-found-title"
                >
                    {title}
                </div>
                <div
                    className="location_not_found_message"
                    id="location-not-found-message"
                >
                    {message}
                </div>
            </div>

            <button
                type="button"
                className="location_not_found_close"
                onClick={closeModal}
                aria-label="Close current location not available popup"
            >
                <AiOutlineClose />
            </button>
        </div>
    );

    const popupRoot =
        typeof document !== "undefined"
            ? document.getElementById("manage_dropdown_leftshift")
            : null;

    return popupRoot ? createPortal(popupContent, popupRoot) : popupContent;
};

export default LocationNotFoundPopup;
